import { merge } from 'lodash';

export const translationsEn = merge(
    {},
    require('tridion.web.ui/src/app/angular/i18n/en.json'),
    require('./en.json')
);
